import StackedBarChart from './StackedBarChart';

export { StackedBarChart };
export default StackedBarChart;
